/* global _wq */

Wee.fn.make('about', {
	init: function() {
		var priv = this.$private,
			$slideBlockWrapper = $('ref:slideBlockWrapper'),
			$slideTrackers = $('ref:slideTrackers');

		priv.manageSliders();
		priv.bindEvents();

		if (window.location.hash) {
			var hash = window.location.hash.substring(1);

			switch (hash) {
				case 'innovators':
					$('ref:blockSelector')[0].click();
				break;
				case 'experts':
					$('ref:blockSelector')[1].click();
				break;
				case 'researchers':
					$('ref:blockSelector')[2].click();
				break;
			}
		}

		priv.checkVideos();

		Wee.screen.map([
			{
				max: 3,
				callback: function() {
					$slideBlockWrapper.after($slideTrackers);
				}
			},
			{
				min: 4,
				callback: function() {
					$slideBlockWrapper.append($slideTrackers);
				}
			}
		]);

		priv.resize();

		$('ref:playBlock').first().find('img').first().on('load', function() {
			priv.one.reCalculateParent();
		});
	}
}, {
	bindEvents: function() {
		$('ref:blockSelector').on('click', function(e, el) {
			window.location.hash = $(el).attr('id');
		});
	},

	manageSliders: function() {
		this.one = Wee.fn.easySlide();

		this.one.init({
			elementRef: 'playBlock',
			trackerRef: 'blockSelector',
			arrows: 'playArrow',
			resizeParent: true
		});

		if ($('ref:slideBlock').length > 1) {
			this.two = Wee.fn.easySlide();

			this.two.init({
				elementRef: 'slideBlock',
				trackerRef: 'slideTracker',
				resizeParent: true
			});
		}
	},

	timer: function() {
		$(Wee._win).on('resize', function() {
			clearTimeout(this.timer);

			this.timer = setTimeout(this.resize(), 500);
		}.bind(this));
	},

	checkVideos: function() {
		var scope = this;

		window._wq = window._wq || [];

		_wq.push({
			'_all': function(video) {
				video.bind('heightchange', function() {
					scope.resize();
				});
			}
		});
	},

	resize: function() {
		Wee.flushHeights.$private.size('blocksContainer', 'block');

		this.one.reCalculateParent();

		if ($('ref:slideBlock').length > 0) {
			this.two.reCalculateParent();
		}
	}
});